import type { ReferencePlane } from '../../../../../reference/ReferencePlane';
import type { StyleSplineProjectionResult } from '../../../model/ProjectionResult';
import type { ResolvedStyleSplineReferenceSource } from '../SketchReferenceSourceResolver';
import type { SupportProjectionPreprocessor } from './SupportProjectionPreprocessor';
import {
	hasUsableCurveExtent,
	projectWorldCoordinatesToPlane,
} from './SplineSupportProjectionPreprocessor';

/**
 * 样式样条源投影预处理器。
 * 说明：
 * 1. 样式样条与普通样条共享投影数学；
 * 2. 单独保留 sourceKind / projectionResultKind，避免 PropertyManager 与 rebuild 混淆两类曲线；
 * 3. 不在这里创建辅助控制折线，目标对象构建器会按样式样条自身协议处理。
 */
export class StyleSplineSupportProjectionPreprocessor
	implements SupportProjectionPreprocessor<ResolvedStyleSplineReferenceSource, StyleSplineProjectionResult>
{
	/**
	 * 执行样式样条投影。
	 *
	 * @param input 投影输入。
	 * @returns 成功时返回 style-spline，退化时返回 null。
	 */
	public projectToTargetPlane(input: {
		source: ResolvedStyleSplineReferenceSource;
		targetReferencePlane: ReferencePlane;
	}): StyleSplineProjectionResult | null {
		const controlPointWorlds = projectWorldCoordinatesToPlane(
			input.source.controlPointWorlds,
			input.targetReferencePlane,
		);
		const curvePointWorlds = projectWorldCoordinatesToPlane(
			input.source.curvePointWorlds,
			input.targetReferencePlane,
		);
		if (!hasUsableCurveExtent(controlPointWorlds) || !hasUsableCurveExtent(curvePointWorlds)) {
			return null;
		}

		return {
			sourceDescriptor: input.source.sourceDescriptor,
			sourceKind: 'style-spline',
			projectionResultKind: 'style-spline',
			diagnostics: [],
			geometryPayload: {
				controlPointWorlds,
				curvePointWorlds,
				curveMetadata: input.source.curveMetadata,
			},
		};
	}
}
